// @flow

import React, { type Node, useState } from 'react';
import styled, { type StyledComponent } from 'styled-components';
import isEmpty from 'lodash-es/isEmpty';

import type { Pet } from '@rover/react-lib/types';
import { CareInstructionsConstants } from '@rover/app/js/constants/translationConstants';

import CareInstruction from './CareInstruction';
import SectionTitle from '../common/SectionTitle';
import SectionSaveButton from '../common/SectionSaveButton';

type Props = {
  pets: Array<Pet>,
  handleSave: () => void,
  handleUpdate: (pet: Pet) => void,
  isCareComplete: boolean,
};

const SectionWrapper: StyledComponent<{}> = styled.div`
  margin-left: 45px;
  margin-right: 45px;
`;

const CareInstructions = ({ pets, handleSave, handleUpdate, isCareComplete }: Props): Node => {
  const [currentlyEditing, setCurrentlyEditing] = useState({});

  const toggleEditing = pet =>
    setCurrentlyEditing({ ...currentlyEditing, [pet.url]: !currentlyEditing[pet.url] });

  const isFormComplete = isEmpty(currentlyEditing) && isCareComplete;

  const save = () => {
    handleSave();
    setCurrentlyEditing({});
  };

  pets.forEach(pet => {
    if (!pet.careInstructions && !currentlyEditing[pet.url]) {
      toggleEditing(pet);
    }
  });

  return (
    <SectionWrapper>
      <SectionTitle isComplete={isFormComplete} titleText={CareInstructionsConstants.title} />
      {pets.map(pet => (
        <CareInstruction
          key={pet.url}
          pet={pet}
          hasMultiplePets={pets.length > 1}
          handleCareInstructionsChange={(careInstructions: string) =>
            handleUpdate({ ...pet, careInstructions })
          }
          value={pet.careInstructions}
          isEditing={currentlyEditing[pet.url]}
          toggleEditing={toggleEditing}
        />
      ))}
      <SectionSaveButton
        isComplete={isFormComplete}
        buttonText={CareInstructionsConstants.save}
        saveMethod={save}
        currentlyEditing={currentlyEditing}
      />
    </SectionWrapper>
  );
};

export default CareInstructions;



// WEBPACK FOOTER //
// ../react-lib/src/pages/conversations/EmergencyFormPage/components/CareInstructions/CareInstructions.jsx